// This shim file is necessary 'cause import and require behave differently. In the specifc instance of stripe's jquery plugin,
// it needs $ to be attached to window before we attempt to import it which doesn't behave as expected since import can't be used inline
// like we can do with require.

import jQuery from 'jquery'

if (window)
  window.$ = jQuery
